
import CelebrateCultureMoments from "../solutions/CelebrateCultureMoments";

export { Page }

function Page() {
  return <CelebrateCultureMoments />;
}
